export type Query = {
  text: string;
  range: number;
  category: string;
  latitude: number;
  longitude: number;
  size: number;
  skip: number;
};

export const DefaultQuery: Query = {
  text: "",
  category: "",
  range: 0,
  latitude: 0,
  longitude: 0,
  size: 50,
  skip: 0,
};
